module.exports = __webpack_public_path__ + "static/media/1017757.e579aa9e.png";